import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, useEffect, useState } from 'react';
import styles from './styles.module.scss';

export const showFullscreenMessage = (content: string): void => {
    dispatchEvent(new CustomEvent('show-fullscreen-message', { detail: { content } }));
}

const FullscreenMessage: FC = (): JSX.Element => {
    const [ show, setShow ] = useState<boolean>(false);
    const [ content, setContent ] = useState<string>('');

    useEffect(() => {
        const handleShow = ({ detail }: any): void => {
            setShow(true);
            setContent(detail.content);
            setTimeout(() => setShow(false), 2500);
        }

        window.addEventListener('show-fullscreen-message', handleShow, true);
        return () => window.removeEventListener('show-fullscreen-message', handleShow, true);
    });

    return (
        <div className={`${styles.container} ${show ? styles.show : ''}`}>
            <div className={styles.content}>
                <FontAwesomeIcon icon={faCheck} />
                <p>{content || 'Actie succesvol uitgevoerd'}</p>
            </div>
        </div>
    );
}

export default FullscreenMessage;
